import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from 'Pods/Shared/Icon/Icon'

import ReportConversationModal from './ReportConversationModal'

class TopHeaderRow extends React.Component {
  constructor() {
    super()

    this.state = { reportModalActive: false }

    this.openReportModal = this.openReportModal.bind(this)
    this.closeReportModal = this.closeReportModal.bind(this)
    this.onArchiveFailure = this.onArchiveFailure.bind(this)
  }

  openReportModal() {
    this.setState({ reportModalActive: true })
  }

  closeReportModal() {
    this.setState({ reportModalActive: false })
  }

  moveToArchive(e) {
    e.preventDefault()

    axios.post('/api/internal/conversations/archive', { conversation_ids: this.props.conversationId })
      .then(this.props.onMoveToArchiveSuccess)
      .catch(this.onArchiveFailure)
  }

  onArchiveFailure() {
    App.events.publish('app:notification:flash:error', 'Unfortunately message couldn\'t be moved to archive.')
  }

  render() {
    return (
      <div className="header__row">
        <div className="header__title u-float-left">
          {this.props.titleElement}
        </div>
        <div className="header__actions u-float-right">
          <Link to="/profile/inbox/">
            <Icon type="chevron-left" />Back to inbox
          </Link>
          {this.props.archived ? (
            <span className="u-mr10 u-ml10"><Icon type="archive" />Archived</span>
          ) : (
            <span className="header-actions__action u-mr10 u-ml10" onClick={(e) => this.moveToArchive(e)}>
              <Icon type="archive" />Move to archive
            </span>
          )
          }
          {this.props.reported ? (
            <span className="u-ml10"><Icon type="exclamation-triangle" />Reported</span>
          ) : (
            <span className="header-actions__action u-ml10" onClick={this.openReportModal}>
              <Icon type="exclamation-triangle" />Report
            </span>
          )
          }
          <ReportConversationModal
            modalIsOpen={this.state.reportModalActive}
            closeModal={this.closeReportModal}
            onReportSuccess={this.props.onReportSuccess}
            recipient={this.props.recipient}
            conversationId={this.props.conversationId}
          />
        </div>
      </div>
    )
  }
}

TopHeaderRow.propTypes = {
  archived: PropTypes.bool,
  reported: PropTypes.bool,
  titleElement: PropTypes.object.isRequired,
  conversationId: PropTypes.string.isRequired,
  onMoveToArchiveSuccess: PropTypes.func.isRequired,
  onReportSuccess: PropTypes.func.isRequired,
  recipient: PropTypes.string.isRequired,
}

TopHeaderRow.defaultPropTypes = {
  archived: false,
  reported: false,
}

export default TopHeaderRow
